import React from 'react';
import { TagsContainer } from '../../../containers/tags.container';
import SpotifyEmbedded from '../../../embedded/spotify.embedded';
import CoverImage from '../../../images/cover.image';
import { VStack } from '../../../layouts/stack.layout';
import Heading from '../../../typography/v2/heading';
import Text from '../../../typography/v2/text';

type MediaCardBodyProps = {
  title: string;
  comment: string;
  tags: string[];
};

export function MediaCardBody(props: MediaCardBodyProps) {
  const { title, comment, tags } = props;
  return (
    <VStack gap="base">
      <VStack gap="sm">
        <Heading variant="secondary">{title}</Heading>
        <TagsContainer tags={tags} />
        <Text color="primary" variant="base" text={comment || ''} />
      </VStack>
    </VStack>
  );
}

type SocialCardBodyProps = {
  comment: string;
  mediaItem?: { id: string; source: 'Spotify' | 'Apple Music' };
  imageUrl?: string;
  link?: string;
  type?: 'internal' | 'external';
};

export function SocialCardBody(props: SocialCardBodyProps) {
  const { comment, mediaItem, imageUrl, link, type } = props;

  return (
    <VStack gap="base">
      <span>
        <Text color="primary" variant="base" text={comment || ''} />
        {type === 'internal' && link && (
          <a href={link} target="_blank" rel="noreferrer">
            <Text variant="link">{link}</Text>
          </a>
        )}
      </span>
      {imageUrl && <CoverImage src={imageUrl} alt={comment || ''} />}
      {/* {mediaItem && mediaItem.source === 'Spotify' && (
        <SpotifyEmbedded id={mediaItem.id} />
      )} */}
    </VStack>
  );
}
